<!--begin::App-->
<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <!--begin::Page-->
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    <ng-container *ngIf="appHeaderDisplay">
      <!--begin::Header-->
      <app-header id="kt_app_header" class="app-header" [ngClass]="appHeaderDefaultClass">
      </app-header>
      <!--end::Header-->
    </ng-container>

    <!--begin::Wrapper-->
    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">

      <ng-container *ngIf="appSidebarDisplay">
        <!--begin::sidebar-->
        <app-sidebar #ktSidebar id="kt_app_sidebar" class="app-sidebar flex-column" [ngClass]="appSidebarDefaultClass"
       data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
        >
        </app-sidebar>
        <!--end::sidebar-->
      </ng-container>

      <ng-container *ngIf="appSidebarPanelDisplay">
        <!-- TODO: app sidebar panel -->
      </ng-container>
      <!--begin::Main-->
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">
          <app-content id=" kt_app_content" class="app-content" [ngClass]="contentCSSClasses"
            [contentContainerCSSClass]="contentContainerCSSClass" [appContentContiner]="appContentContiner"
            [appContentContainerClass]="appContentContainerClass">
          </app-content>
        </div>
        <!--end::Content wrapper-->
        <ng-container *ngIf="appFooterDisplay">
          <app-footer class="app-footer" [ngClass]="appFooterCSSClass" id="kt_app_footer"
            [appFooterContainerCSSClass]="appFooterContainerCSSClass"></app-footer>
        </ng-container>
      </div>
      <!--end:::Main-->
    </div>
    <!--end::Wrapper-->

  </div>
  <!--end::Page-->
</div>
<!--end::App-->

<app-scripts-init></app-scripts-init>
<ng-container>
  <app-scroll-top id="kt_scrolltop" class="scrolltop" data-kt-scrolltop="true"></app-scroll-top>
</ng-container>
<!-- begin:: Drawers -->
<app-activity-drawer></app-activity-drawer>
<app-messenger-drawer></app-messenger-drawer>
<!-- end:: Drawers -->


<!-- begin:: Modals -->
<app-main-modal></app-main-modal>
<app-invite-users-modal></app-invite-users-modal>
<app-upgrade-plan-modal></app-upgrade-plan-modal>
<!-- end:: Modals -->

<div class="floating-button-wrapper">
  <div id="floating-button-knowlarity" (click)="togglePopup()">
    <i class="bi bi-info-circle info-icon"></i>
  </div>
</div>

<div id="popup-container-knowlarity" *ngIf="isOpen">
  <div class="popup">
    <!-- Content of the popup -->
    <!-- <span (click)="closePopup()" class="close-icon">&times;</span> -->
    <div class="d-flex justify-content-end">
    <div
          class="btn btn-active-color-primary"
          (click)="closePopup()"
          style="padding: 0px !important;"
        >
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        </div>
    <ul style="margin-bottom: 0px !important;">
      <li>
        Please note that you need to enable Knowlarity Cloud Telephony service to make calls and access call logs through PropHero. Please reach out to PropHero support for further details.
      </li>
      <li>
        If you are already using Knowlarity, please use the same username and password to log in.
      </li>
    </ul>
  </div>
</div>
